<template>
  <div class="about-page">
    <!-- Hero Header -->
    <section class="about-hero">
      <div class="app-container">
        <div class="about-hero__inner">
          <span class="eyebrow anim-fade-up">
            <i class="bi bi-shield-check text-flame"></i>
            {{ $t('about.eyebrow') }}
          </span>
          <h1 class="about-hero__title anim-fade-up anim-delay-1">
            {{ $t('about.titleA') }} <span class="text-flame">{{ $t('about.titleB') }}</span>
          </h1>
          <p class="about-hero__desc anim-fade-up anim-delay-2">
            {{ $t('about.desc') }}
          </p>
        </div>
      </div>
    </section>

    <!-- Content & Values Section -->
    <section class="section about-content">
      <div class="app-container">
        <!-- Untuk siapa -->
        <div class="about-grid">
          <article class="ui-card about-card">
            <div class="about-card__icon" style="color: var(--flame-500, #ea580c);">
              <i class="bi bi-sliders"></i>
            </div>
            <h3 class="about-card__title">{{ $t('about.panitiaTitle') }}</h3>
            <p class="about-card__text">{{ $t('about.panitiaText') }}</p>
          </article>

          <article class="ui-card about-card">
            <div class="about-card__icon text-accent">
              <i class="bi bi-people-fill"></i>
            </div>
            <h3 class="about-card__title">{{ $t('about.officialTitle') }}</h3>
            <p class="about-card__text">{{ $t('about.officialText') }}</p>
          </article>

          <article class="ui-card about-card">
            <div class="about-card__icon text-success">
              <i class="bi bi-calendar2-week-fill"></i>
            </div>
            <h3 class="about-card__title">{{ $t('about.publikTitle') }}</h3>
            <p class="about-card__text">{{ $t('about.publikText') }}</p>
          </article>
        </div>

        <!-- CTA Box -->
        <div class="about-cta ui-card ui-card--flame">
          <div class="about-cta__content">
            <h3 class="about-cta__title">{{ $t('about.ctaTitle') }}</h3>
            <p class="about-cta__desc">{{ $t('about.ctaDesc') }}</p>
            <div class="about-cta__actions">
              <router-link to="/detail" class="ui-btn ui-btn--primary ui-btn--md">
                <i class="bi bi-trophy-fill"></i> {{ $t('about.ctaButton') }}
              </router-link>
            </div>
          </div>
        </div>

      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'AboutPage',
};
</script>

<style scoped>
.about-page {
  min-height: 100vh;
  padding-bottom: var(--space-16);
}

/* ═════════════════ HERO ═════════════════ */
.about-hero {
  position: relative;
  padding-block: var(--space-12) var(--space-10);
  background: var(--hero-bg);
  text-align: center;
  border-bottom: 1px solid var(--border-subtle);
}

@media (min-width: 768px) {
  .about-hero {
    padding-block: var(--space-20) var(--space-16);
  }
}

.about-hero__inner {
  max-width: 760px;
  margin-inline: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.about-hero__title {
  font-size: clamp(1.85rem, 5vw, 3.25rem);
  font-weight: 800;
  line-height: 1.25;
  margin-block: var(--space-4) var(--space-5);
  letter-spacing: -0.02em;
}

.about-hero__desc {
  font-size: clamp(var(--text-base), 2vw, var(--text-lg));
  color: var(--text-secondary);
  line-height: 1.65;
  margin: 0;
}

/* ═════════════════ VALUE CARDS ═════════════════ */
.about-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: var(--space-6);
  margin-bottom: var(--space-10);
}

@media (min-width: 768px) {
  .about-grid {
    grid-template-columns: repeat(3, 1fr);
  }
}

.about-card {
  padding: var(--space-6);
  border-radius: var(--radius-2xl);
  display: flex;
  flex-direction: column;
  gap: var(--space-3);
  transition: transform var(--transition-normal), box-shadow var(--transition-normal);
}

.about-card__icon {
  width: 48px;
  height: 48px;
  border-radius: var(--radius-lg);
  background: var(--accent-subtle);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.5rem;
}

.about-card__title {
  font-size: var(--text-xl);
  font-weight: 700;
  margin: 0;
}

.about-card__text {
  font-size: var(--text-sm);
  color: var(--text-secondary);
  line-height: 1.6;
  margin: 0;
}

/* ═════════════════ CTA ═════════════════ */
.about-cta {
  padding: var(--space-8) var(--space-6);
  border-radius: var(--radius-2xl);
  text-align: center;
  max-width: 860px;
  margin-inline: auto;
  border: 1px solid color-mix(in srgb, var(--flame-500) 25%, var(--border-default));
}

@media (min-width: 768px) {
  .about-cta {
    padding: var(--space-12) var(--space-8);
  }
}

.about-cta__title {
  font-size: clamp(1.35rem, 3vw, var(--text-3xl));
  font-weight: 800;
  margin: 0 0 var(--space-3);
}

.about-cta__desc {
  font-size: var(--text-base);
  color: var(--text-secondary);
  margin: 0 auto var(--space-6);
  max-width: 48ch;
}

.about-cta__actions {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: var(--space-3);
}
</style>